import Dexie from 'dexie';
import { ITrail } from './interfaces/ITrail';
import { Place } from './Place';
import { Story } from './Story';
import { ITaxonomy } from './interfaces/ITaxonomy';

export class PWADatabase extends Dexie {
	places!: Dexie.Table<Place>;
	trails!: Dexie.Table<ITrail>;
	stories!: Dexie.Table<Story>;
	activities!: Dexie.Table<ITaxonomy>;
	topics!: Dexie.Table<ITaxonomy>;

	constructor() {
		super('PWADatabase');
		this.version(5).stores({
			places: 'id&, title, featured',
			trails: 'id&, title',
			stories: 'id&, title',
			activities: 'id&, slug',
			topics: 'id&, slug',
		});

		this.places.mapToClass(Place);
		this.stories.mapToClass(Story);
	}
}
